import React from 'react';
import EditProtocolForm from '../components/EditProtocolForm';

const EditProtocolPage: React.FC = () => {
    return <div className="page-container">
    <div className="page-content">
      <EditProtocolForm />
    </div>
  </div>
   
};

export default EditProtocolPage;
